import React, { useState, useEffect } from "react";
import { Modal, Button, Container, Row, Col, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import PoServices from '../../../services/PoServices'; // adjust path to where updateSupplier is

const SupplierEditModal = ({ show, handleClose, admin,test }) => {
  const [formData, setFormData] = useState({
    name: "",
    contactPerson: "",
    email: [""],
    mobileNo: [""],
    GSTNo: "",
    address: {
      street: "",
      city: "",
      state: "",
      pincode: "",
      country: "",
    },
    status: "active",
  });

  // Populate form with existing supplier data when modal opens
  useEffect(() => {
    if (admin) {
      setFormData({
        name: admin.name || "",
        contactPerson: admin.contactPerson || "",
        email: admin.email || [""],
        mobileNo: admin.mobileNo || [""],
        GSTNo: admin.GSTNo || "",
        address: {
          street: admin.address?.street || "",
          city: admin.address?.city || "",
          state: admin.address?.state || "",
          pincode: admin.address?.pincode || "",
          country: admin.address?.country || "",
        },
        status: admin.status || "active",
      });
    }
  }, [admin]);

  // Handle form input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    // For nested address fields
    if (name.startsWith("address.")) {
      const field = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        address: { ...prev.address, [field]: value },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Handle array fields like email and mobileNo
  const handleArrayChange = (e, key, index) => {
    const value = e.target.value;
    setFormData((prev) => {
      const updatedArray = [...prev[key]];
      updatedArray[index] = value;
      return { ...prev, [key]: updatedArray };
    });
  };

  // Submit updated data
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await PoServices.updateSupplier(admin._id, formData);
      Swal.fire("Updated!", "Supplier details updated successfully", "success");
    // Since test is setTest function
    test(prev => prev + 1);
      handleClose();
    } catch (error) {
      Swal.fire("Error", "Failed to update supplier", "error");
    }
  };

  return (
    <Modal className="fade" show={show} onHide={handleClose}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>
            <i className="fas fa-edit"></i> Edit Supplier Details
          </Modal.Title>
          <Button variant="" className="btn-close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Supplier Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Contact Person</Form.Label>
                  <Form.Control
                    type="text"
                    name="contactPerson"
                    value={formData.contactPerson}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={formData.email[0]}
                    onChange={(e) => handleArrayChange(e, "email", 0)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>Mobile No</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.mobileNo[0]}
                    onChange={(e) => handleArrayChange(e, "mobileNo", 0)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>GST No</Form.Label>
                  <Form.Control
                    type="text"
                    name="GSTNo"
                    value={formData.GSTNo}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              {/* Address Fields */}
              <Col md="12" className="mt-3">
                <h6>Address</h6>
              </Col>
              {["street", "city", "state", "pincode", "country"].map((field) => (
                <Col md="6" key={field}>
                  <Form.Group>
                    <Form.Label>{field.charAt(0).toUpperCase() + field.slice(1)}</Form.Label>
                    <Form.Control
                      type="text"
                      name={`address.${field}`}
                      value={formData.address[field]}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              ))}
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit">
            Save changes
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default SupplierEditModal;
